import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2, Trash2, AlertTriangle } from "lucide-react";

interface DeleteReferralCampaignConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  referralCampaignDetails: string;
  referralCampaignId: number;
  onConfirm: (referralCampaignId: number) => void;
  isLoading?: boolean;
}

const DeleteReferralCampaignConfirmation = ({
  open,
  onOpenChange,
  referralCampaignDetails,
  referralCampaignId,
  onConfirm,
  isLoading = false,
}: DeleteReferralCampaignConfirmationProps) => {
  const handleConfirm = () => {
    onConfirm(referralCampaignId);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-destructive" />
            Delete Referral Campaign
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the referral campaign "
            <span className="font-semibold">{referralCampaignDetails}</span>"?
            <br />
            <br />
            This action cannot be undone. The referral campaign will be permanently removed
            from the system and any ongoing referrals will be affected.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isLoading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <Trash2 className="w-4 h-4 mr-2" />
                Delete Campaign
              </>
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteReferralCampaignConfirmation;